import EmptyView1 from '../../layouts/EmptyView1'
import Login from './Login'

export default EmptyView1(Login)
